module.exports = __webpack_public_path__ + "static/media/Swashakthi-SHG-Blog-2.ede40f06.webp";